import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import cn from 'classnames';
import './BulkGiftingModalMessage.scss';

import { matchScrollHeight } from '../../Helpers/helpers';
import { getBrandSettings } from '../../Helpers/user_helpers';

import SelectOption from '../General/SelectOption';

const BulkGiftingModalMessage = props => {
  const { user, message, setMessage } = props;
  const settings = getBrandSettings(user);

  /*
    Templates Handling
  */
  const [isUsingTemplate, setIsUsingTemplate] = useState(false);
  const [isUpdatingTemplate, setIsUpdatingTemplate] = useState(false);
  const isDifferentThanTemplate = (settings.sendGiftingTemplate || '') !== message;
  const updateTemplate = async () => {
    setIsUpdatingTemplate(true);
    await props.updateBrandSettings({ sendGiftingTemplate: message });
    setIsUpdatingTemplate(false);
  };

  /*
    Variables Handling
  */
  const [curCursorLocation, setCurCursorLocation] = useState(0);
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keyup', e => setCurCursorLocation(inputRef.current?.selectionStart));
      inputRef.current.addEventListener('mouseup', e => setCurCursorLocation(inputRef.current?.selectionStart));
    }
  }, [inputRef]);
  const variableOptions = [
    { value: '{{FIRSTNAME}}', label: 'First Name' },
    { value: '{{FULLNAME}}', label: 'Full Name' },
    { value: '{{BRANDNAME}}', label: 'Brand Name' }
  ];
  const selectVariableToAdd = data => {
    const newMessage = message.slice(0, curCursorLocation) + data.value + message.slice(curCursorLocation);
    props.setMessage(newMessage);
  };

  return (
    <div className='bulk-gifting-message-container'>
      <div className='message-template'>
        <div></div>
        <textarea
          rows={6}
          placeholder='Feel free to include details about the gifting request'
          className='bulk-gifting-message'
          onChange={e => setMessage(e.target.value)}
          value={message}
          ref={ref => matchScrollHeight(ref)}
        />
      </div>
      <div className='action-btns'>
        {!isUsingTemplate && (
          <div
            className={cn('use-template action-btn', { secondary: isUsingTemplate })}
            onClick={() => {
              setIsUsingTemplate(!isUsingTemplate);
              setMessage(settings.sendGiftingTemplate || '');
            }}
          >
            Use Gifting Template
          </div>
        )}
        {isUsingTemplate && (
          <>
            {isDifferentThanTemplate && (
              <div onClick={updateTemplate} className='action-btn update-template secondary'>
                {isUpdatingTemplate ? 'Updating...' : 'Update Template'}
              </div>
            )}
            <div className='select'>
              <Select
                unstyled
                placeholder='Add Variable'
                classNamePrefix='variable-select'
                onChange={selectVariableToAdd}
                className='variable-select'
                options={variableOptions}
                value={null}
                components={{ Option: SelectOption }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

BulkGiftingModalMessage.propTypes = {
  user: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  setMessage: PropTypes.func.isRequired,
  updateBrandSettings: PropTypes.func.isRequired
};

export default BulkGiftingModalMessage;
